import { Component, OnDestroy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { NgIf } from '@angular/common';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'dialog-default',
    templateUrl: './dialog-default.component.html',
    styleUrls: ['./dialog-default.component.scss'],
    imports: [NgIf, MatDialogTitle]
})
export class DialogDefaultComponent implements OnDestroy {
    dialogRef = inject<MatDialogRef<DialogDefaultComponent>>(MatDialogRef);
    data = inject<{
    title: string;
    message: string;
    yes: boolean;
    no: boolean;
}>(MAT_DIALOG_DATA);


    result: boolean;

    yes() {
        this.result = true;
        this.dialogRef.close(this.result);
    }

    no() {
        this.result = false;
        this.dialogRef.close(this.result);
    }


    ngOnDestroy() {
        if (this.result === undefined) {
            this.dialogRef.close(false);
        }
    }
}
